import styled from 'styled-components'


export const BlogThumbNail = styled.img`
  width:100%;
  height:auto;
`

export const Date = styled.p`
  margin: 2px;
  color:#2ecc71;
`

export const Description = styled.p`
  font-size:14px
`

export const Title = styled.p`
  color: #341f97;
  font-weight:bold;
  margin:0;
`

export const BlogContainer = styled.div`
  width:100%;
  padding:0.5em;
  margin-top:30px;
`;



// WEBPACK FOOTER //
// ./src/BlogCard/BlogCard.style.js